export const formatCurrency = (value, currency = "EUR", options = {}) => {
  let val = isNaN(value) ? 0 : Number(value);
  // fix -0
  if (val > -0.005 && val < 0) val = 0;
  return new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: currency,
    options: {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      ...options
    }
  }).format(Number(val));
};
